import axios from 'axios';
import { API_URL } from '../config';

export const getSubscriptions = async (token: string) => {
    const response = await axios.get(`${API_URL}/subscriptions/`,
    {
        headers: {
            'Authorization': `${token}`,
        },
    });
    return response.data;
};

export const getSubscriptionCompany = async (token: string, id: number) => {
    const response = await axios.get(`${API_URL}/subscriptions/${id}/`, {
        headers: {
            'Authorization': token,
        }
    });
    return response.data;
};

export const updateSubscription = async (token: string, id: number, quantity: number) => {
    const response = await axios.patch(`${API_URL}/subscriptions/${id}/`, 
    {
        quantity: quantity,
    }, 
    {
        headers: {
            'Authorization': token,
        }
    });
    return response.data;
};

export const upgradeSubscription = async (token: string, id: number, planCode: string) => {
    const response = await axios.put(`${API_URL}/subscriptions/${id}/upgrade`, 
    {
        plan_code: planCode,
    }, 
    {
        headers: {
            'Authorization': token,
        }
    });
    return response.data;
};

export const deleteSubscription = async (token: string, id: number) => {
    const response = await axios.delete(`${API_URL}/subscriptions/${id}/`,
    {
        headers: {
        'Authorization': `${token}`,
        },
    });
    return response.data;
};
  